var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-page',{attrs:{"flex-column":"","card-content":""}},[(_vm.code)?_c('query-view',_vm._b({attrs:{"config-code":_vm.code}},'query-view',_vm.$attrs,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }